/**
 * Created by vladislav on 26/10/2022
 */

const CustomerIngredientView = cc.Node.extend({
    ctor: function (ingredient, type, options) {
        this._super();
        this.type = type;
        this.ingredient = ingredient;
        this.onTap = options && options.onTap;
        this.isExactStage = options && options.isExactStage;

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(this.getStyles());

        this.createIngredient();
        this.createCheckMark();
        this.createHelp();

        this.onAmountChanged();
    },

    getStyles: function () {
        const largerViews = cleverapps.meta.getSelectedLocation().locationConfig.largerPrizeAndCustomerViews;
        switch (this.type) {
            case CustomerIngredientView.TYPE_INFOVIEW: return largerViews ? cleverapps.styles.CustomerIngredientViewInfoViewLarger : cleverapps.styles.CustomerIngredientViewInfoView;
            case CustomerIngredientView.TYPE_EXTENDEDVIEW: return cleverapps.styles.CustomerIngredientViewExtendedInfo;
        }
    },

    createIngredient: function () {
        const styles = this.getStyles();

        if (this.ingredient.ingredient) {
            this.icon = this.type === CustomerIngredientView.TYPE_INFOVIEW
                ? Map2dLocation.currentLocation.harvested.getIngredientSmallIcon(this.ingredient.ingredient)
                : Map2dLocation.currentLocation.harvested.getIngredientIcon(this.ingredient.ingredient);
        } else {
            this.icon = UnitView.getUnitImage(this.ingredient.unit, { customStatic: true, preferStatic: true, useLibraryAnchors: true });
        }

        if (this.type === CustomerIngredientView.TYPE_INFOVIEW) {
            const readyBg = this.readyBg = new cc.Scale9Sprite(bundles.merge.frames.bg_collected);
            readyBg.setContentSize2(styles.bg);
            readyBg.setAlignment(styles.bg);
            this.addChild(readyBg);
            const scale = cleverapps.skins.getSlot("CustomerInfoViewIconScale") || 1.2;
            cleverapps.UI.fitToBox(this.icon, { width: styles.bg.width, height: scale * styles.bg.height, maxScale: 1.2 });
            this.addChild(this.icon);
        } else {
            const bg = new cc.Scale9Sprite(bundles.extended_customer_view.frames.extended_customer_ingredients_bg);
            bg.setContentSize2(this.width, this.height);
            bg.setAnchorPoint(0.5, 1);
            bg.setAlignment(this.width / 2, this.height);
            this.addChild(bg);

            cleverapps.UI.fitToBox(this.icon, { width: this.width - styles.bgPadding, height: this.height - styles.bgPadding });
            bg.addChild(this.icon);
        }
        this.icon.setPosition(this.width / 2, this.height / 2 + styles.icon.offsetY);
    },

    createCheckMark: function () {
        this.checkMark = new cc.Sprite(bundles.customer_check_marks.frames.customer_check_mark);
        this.addChild(this.checkMark);
        this.checkMark.setAlignment(this.getStyles().checkMark);
        this.checkMarkShown = false;
    },

    createHelp: function () {
        const onDoubleClick = cleverapps.config.debugMode
            ? () => Map2d.currentMap.stock.spawnIngredients([this.ingredient], true)
            : undefined;

        const helpParams = this.getHelpParams();
        if (helpParams) {
            helpParams.allowScrollWithFocus = true;
            this.help = new cc.Sprite(bundles.extended_customer_view.frames.extended_customer_magnifier);
            const helpStyles = this.getStyles().help;
            if (helpStyles && helpStyles.scale) {
                this.help.baseScale = helpStyles.scale;
                this.help.setScale(helpStyles.scale);
            }
            cleverapps.UI.applyHover(this.help);

            const doHelp = () => {
                Map2dScroller.currentScroller.cancelZoomOut();
                Map2d.currentMap.customers.selectCustomer(undefined);

                if (cleverapps.tutorial.isActive()) {
                    cleverapps.tutorial.trigger("ingredientHelpClick");
                } else if (helpParams.missionType !== undefined) {
                    Mineable.FindMissionSource(helpParams.missionType);
                } else if (helpParams.ingredient) {
                    UnitLocator.findPrize(helpParams);
                } else if (helpParams.resource && !helpParams.getFindTargets) {
                    UnitLocator.find(Map2d.MERGE, { code: helpParams.unit.code }, helpParams);
                } else {
                    helpParams.includePrizeView = true;
                    UnitLocator.find(Map2d.SPAWN, helpParams.unit, helpParams);
                }
            };

            cleverapps.UI.onClick(this.help, doHelp, { swallowEvents: true });

            if (this.type === CustomerIngredientView.TYPE_EXTENDEDVIEW) {
                const extOptions = { onClick: doHelp, swallowEvents: true };
                if (onDoubleClick) {
                    extOptions.onDoubleClick = onDoubleClick;
                }
                this.helpHandler = cleverapps.pointerManager.create(this, extOptions);
            }
            this.addChild(this.help);
            this.help.setAlignment(this.getStyles().help);
        }

        if (this.type === CustomerIngredientView.TYPE_INFOVIEW && (this.onTap || onDoubleClick)) {
            const tapOptions = { swallowEvents: true };
            if (this.onTap) {
                tapOptions.onClick = this.onTap;
            }
            if (onDoubleClick) {
                tapOptions.onDoubleClick = onDoubleClick;
            }
            cleverapps.pointerManager.create(this, tapOptions);
        }
    },

    onAmountChanged: function () {
        if (this.progress) {
            this.progress.removeFromParent();
            delete this.progress;
        }

        const isReady = Map2d.currentMap.stock.getLackingAmount(this.ingredient) === 0;

        if (!isReady || this.type !== CustomerIngredientView.TYPE_INFOVIEW) {
            this.progress = this.createProgress();
            if (this.progress) {
                this.progress.setCascadeOpacityEnabledRecursively(true);
                this.addChild(this.progress);

                this.progress.setAlignment(this.getStyles().progress);
                cleverapps.UI.fitToBox(this.progress, {
                    width: this.width * 0.9
                });
            }
        }

        let justGotReady = false;
        this.readyBg && this.readyBg.setVisible(isReady);
        this.checkMark.setVisible(isReady);
        if (isReady) {
            if (!this.checkMarkShown) {
                this.checkMarkShown = true;
                justGotReady = true;

                this.checkMark.runAction(new cc.Sequence(
                    new cc.FadeOut(0),
                    new cc.ScaleTo(0, 2.65),
                    new cc.Spawn(
                        new cc.FadeIn(0.13),
                        new cc.ScaleTo(0.27, 1).easing(cc.easeInOut(1))
                    ),
                    new cc.ScaleTo(0.17, 1.1).easing(cc.easeInOut(1)),
                    new cc.ScaleTo(0.13, 1).easing(cc.easeInOut(1))
                ));

                if (this.readyBg) {
                    this.icon.baseScale = this.icon.getScale();

                    this.readyBg.setOpacity(0);
                    this.readyBg.runAction(new cc.Sequence(
                        new cc.DelayTime(0.35),
                        new cc.FadeIn(0.3)
                    ));

                    const iconScale = this.icon.baseScale || 1;
                    this.icon.runAction(new cc.Sequence(
                        new cc.DelayTime(0.23),
                        new cc.ScaleTo(0.2, 1.28 * iconScale).easing(cc.easeInOut(1)),
                        new cc.ScaleTo(0.17, iconScale).easing(cc.easeInOut(1))
                    ));
                }
            }
        } else {
            this.checkMarkShown = false;
        }
        if (this.help) {
            this.help.setVisible(!isReady);
            if (this.helpHandler) {
                this.helpHandler.setEnabled(!isReady);
            }
        }

        this.updateEnabled();

        return justGotReady;
    },

    updateEnabled: function () {
        if ([CustomerIngredientView.TYPE_INFOVIEW, CustomerIngredientView.TYPE_EXTENDEDVIEW].includes(this.type)) {
            return;
        }

        const enabled = Map2d.currentMap.stock.getLackingAmount(this.ingredient) === 0;

        [this.icon, this.progress].filter(Boolean).forEach((node) => {
            if (enabled) {
                node.setOpacity(255);
                node.setColor(new cc.Color(255, 255, 255, 255));
            } else {
                node.setOpacity(160);
                node.setColor(new cc.Color(180, 180, 180, 255));
            }
        });
    },

    createProgress: function () {
        const lacking = Map2d.currentMap.stock.getLackingAmount(this.ingredient);
        if (this.type === CustomerIngredientView.TYPE_INFOVIEW) {
            if (lacking === 1 && !cleverapps.skins.getSlot("showOneIngredientLeft")) {
                return undefined;
            }
            return cleverapps.UI.generateOnlyText(lacking, cleverapps.styles.FONTS.CUSTOMER_INGREDIENT_TEXT);
        }

        const font = cleverapps.styles.FONTS.CUSTOMER_INGREDIENT_TEXT;
        const currentAmount = cleverapps.UI.generateOnlyText(Map2d.currentMap.stock.getStockAmount(this.ingredient), font);

        const slash = cleverapps.UI.generateOnlyText("/", font);
        const requiredAmount = cleverapps.UI.generateOnlyText(this.ingredient.amount, font);

        return new cleverapps.Layout([currentAmount, slash, requiredAmount], {
            margin: this.getStyles().progress.margin,
            direction: cleverapps.UI.HORIZONTAL
        });
    },

    showUp: function () {
        this.setScale(0.3);
        const markToShow = Map2d.currentMap.stock.getLackingAmount(this.ingredient) === 0 ? this.checkMark : this.help;
        if (markToShow) {
            markToShow.setScale(2);
            markToShow.setVisible(false);
        }

        this.runAction(new cc.Sequence(
            new cc.Hide(),
            new cc.DelayTime(0.3),
            new cc.Show(),
            new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut()),
            new cc.CallFunc(() => {
                if (markToShow) {
                    markToShow.runAction(new cc.Sequence(
                        new cc.DelayTime(0.7),
                        new cc.Show(),
                        new cc.ScaleTo(0.5, 1).easing(cc.easeBackOut())
                    ));
                }
            })
        ));
    },

    getHelpParams: function () {
        if (this.ingredient.unit) {
            const helpParams = {
                unit: this.ingredient.unit,
                minUnits: 1
            };

            if (this.isExactStage) {
                helpParams.exactStage = true;
            }

            if (!this.isExactStage && helpParams.unit.stage > 1) {
                helpParams.skipUnitStage = true;
            }

            if (Families[this.ingredient.unit.code].type === "campaignorder") {
                helpParams.useStageForCustomerSearch = true;
            }

            if (Families[this.ingredient.unit.code].missionType !== undefined) {
                helpParams.missionType = Families[this.ingredient.unit.code].missionType;
            }

            if (Families[this.ingredient.unit.code].locators) {
                helpParams.getFindTargets = function () {
                    return Families[this.ingredient.unit.code].locators;
                }.bind(this);
            }

            if (!this.isExactStage && Families[this.ingredient.unit.code].type.indexOf("resource") !== -1) {
                helpParams.resource = true;
            }

            if (Families[this.ingredient.unit.code].type.indexOf("order") !== -1) {
                helpParams.tryAdvice = true;
                helpParams.minUnits = 3;
            }

            return helpParams;
        }

        if (this.ingredient.ingredient) {
            return {
                ingredient: this.ingredient.ingredient
            };
        }
    }
});

CustomerIngredientView.TYPE_INFOVIEW = 1;
CustomerIngredientView.TYPE_EXTENDEDVIEW = 2;

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CUSTOMER_INGREDIENT_TEXT: {
        size: 42,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            size: 3,
            color: new cc.Color(96, 51, 40, 255)
        }
    }
});

cleverapps.styles.CustomerIngredientViewInfoView = {
    width: 80,
    height: 80,
    bg: {
        width: 100,
        height: 80,
        x: { align: "center", dx: -2 },
        y: { align: "center", dy: -1 }
    },

    icon: {
        offsetY: 6
    },

    progress: {
        margin: -4,

        x: { align: "right", dx: -6 },
        y: { align: "bottom", dy: -4 }
    },

    help: {
        scale: 0.7,
        x: { align: "right", dx: 28 },
        y: { align: "top", dy: 14 }
    },

    checkMark: {
        x: { align: "right", dx: 15 },
        y: { align: "bottom", dy: 4 }
    }
};

cleverapps.styles.CustomerIngredientViewInfoViewLarger = {
    width: 96,
    height: 96,
    bg: {
        width: 120,
        height: 96,
        x: { align: "center", dx: -2 },
        y: { align: "center", dy: -1 }
    },

    icon: {
        offsetY: 6
    },

    progress: {
        margin: -4,

        x: { align: "right", dx: -6 },
        y: { align: "bottom", dy: -4 }
    },

    help: {
        scale: 1,
        x: { align: "right", dx: 47 },
        y: { align: "top", dy: 32 }
    },

    checkMark: {
        x: { align: "right", dx: 15 },
        y: { align: "bottom", dy: 4 }
    }
};

cleverapps.styles.CustomerIngredientViewExtendedInfo = {
    width: 130,
    height: 130,
    bgPadding: 26,

    icon: {
        offsetY: 2
    },

    progress: {
        margin: -5,
        x: { align: "center" },
        y: { align: "bottom", dy: 2 }
    },

    help: {
        scale: 1,
        x: { align: "right", dx: 22 },
        y: { align: "top", dy: 14 }
    },

    checkMark: {
        x: { align: "right", dx: 10 },
        y: { align: "top", dy: 5 }
    }
};